/**
 * AeraClear Air Purifier PDP — Interactive JS
 *
 * Gallery swap, purchase type toggle (subscribe/onetime),
 * gift selector, savings tracker, CTA updates, shipping urgency,
 * FAQ accordion, scroll animations, add-to-cart via /cart/add.js,
 * cart drawer integration, and out-of-stock redirect logic.
 *
 * Image URLs are injected by Liquid via onclick attributes on gallery
 * thumbnails using Shopify's `| asset_url` filter.
 */

/* ── View item event (Google view_item / Meta ViewContent) ───────── */

(function () {
  var ta = window.TrainingAnalytics;
  if (!ta) return;

  var mapEl = document.getElementById("air-purifier-variant-map");
  if (!mapEl) return;

  try {
    var data = JSON.parse(mapEl.textContent);
    if (!data.product_id || !data.variants || !data.variants.length) return;

    var v = data.variants[0];

    // Use selling plan price when available (subscribe is the default selection)
    var hasSellingPlan =
      v.selling_plan_allocations && v.selling_plan_allocations.length > 0;
    var viewPrice = hasSellingPlan
      ? v.selling_plan_allocations[0].per_delivery_price
      : v.price;
    var sellingPlanAlloc = hasSellingPlan
      ? {
          selling_plan: {
            id: v.selling_plan_allocations[0].selling_plan_id,
            name: v.selling_plan_allocations[0].selling_plan_name,
          },
          per_delivery_price: v.selling_plan_allocations[0].per_delivery_price,
          compare_at_price: v.selling_plan_allocations[0].compare_at_price,
        }
      : null;

    var fakeCart = {
      total_price: viewPrice,
      currency:
        window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active
          ? window.Shopify.currency.active
          : "USD",
      item_count: 1,
      items: [
        {
          product_id: data.product_id,
          product_title: "AeraClear - Air Purifier",
          variant_id: v.id,
          variant_title: v.title,
          product_type: "Air Purifier",
          vendor: "AeraClear",
          url: window.location.pathname,
          image: null,
          sku: null,
          final_price: viewPrice,
          quantity: 1,
          selling_plan_allocation: sellingPlanAlloc,
        },
      ],
    };

    ta.pushEventOnce("view_item_stape", fakeCart, { pageType: "product" });
  } catch (e) {
    // Analytics failure is non-blocking
  }
})();

/* ── Gallery swap ─────────────────────────────────────────────────── */

var _gallerySwapTimer = null;
function swapMain(thumb, src) {
  var mainImg = document.querySelector(".gallery-main img");
  if (mainImg) {
    if (_gallerySwapTimer) clearTimeout(_gallerySwapTimer);
    mainImg.style.transition = "opacity 0.15s ease";
    mainImg.style.opacity = "0";
    _gallerySwapTimer = setTimeout(function () {
      _gallerySwapTimer = null;
      mainImg.src = src;
      mainImg.style.opacity = "1";
    }, 150);
  }
  document.querySelectorAll(".gallery-thumb").forEach(function (t) {
    t.classList.remove("active");
  });
  thumb.classList.add("active");
}

/* ── Product data ─────────────────────────────────────────────────── */

var variantMap = null;
try {
  var mapEl = document.getElementById("air-purifier-variant-map");
  if (mapEl) variantMap = JSON.parse(mapEl.textContent);
} catch (e) {
  console.warn("Air Purifier: Could not parse variant map", e);
}

/* ── Pricing state ────────────────────────────────────────────────── */

var currentPurchaseType = "subscribe"; // 'subscribe' or 'onetime'
var currentVariantId = null;
var currentSellingPlanId = null;

// Prices in cents
var onetimePrice = 23900;
var onetimeCompareAt = 29900;
var subscribePrice = 17900; // $179
var subscribeCompareAt = 23900; // compare at $239 (the onetime price)

var giftState = { filter: true, strips: true, guide: true };
var giftValues = { filter: 39, strips: 14, guide: 12 };

// Initialize from variant map
(function () {
  if (!variantMap) return;
  if (variantMap.variants && variantMap.variants.length > 0) {
    var v = variantMap.variants[0];
    currentVariantId = v.id;
    onetimePrice = v.price;
    onetimeCompareAt = v.compare_at_price || 22900;

    // Check for selling plan allocation
    if (v.selling_plan_allocations && v.selling_plan_allocations.length > 0) {
      var alloc = v.selling_plan_allocations[0];
      currentSellingPlanId = alloc.selling_plan_id;
      subscribePrice = alloc.per_delivery_price;
      subscribeCompareAt = alloc.compare_at_price || onetimePrice;
    }
  }
})();

/* ── CTA button updates ──────────────────────────────────────────── */

function getActivePrice() {
  return currentPurchaseType === "subscribe" ? subscribePrice : onetimePrice;
}

function getActiveCompareAt() {
  return currentPurchaseType === "subscribe"
    ? onetimeCompareAt
    : onetimeCompareAt;
}

function getBaseDiscount() {
  return Math.round((onetimeCompareAt - getActivePrice()) / 100);
}

function updateCtaButtons() {
  var priceNum = Math.round(getActivePrice() / 100);
  var displayPrice = "$" + priceNum;

  var ctaBtn = document.getElementById("cta-btn");
  if (ctaBtn) {
    ctaBtn.innerHTML =
      'Add to Cart — <span id="cta-price" style="font-weight:700;">' +
      displayPrice +
      '</span> &nbsp; <span class="arrow">→</span>';
  }

  var ctaBtnBottom = document.querySelector(".final-cta .btn-primary");
  if (ctaBtnBottom) {
    ctaBtnBottom.innerHTML = "Add to Cart — " + displayPrice + " &nbsp; →";
  }

  // Nav button
  var navBtn = document.querySelector(".btn-nav[data-ps-atc-btn]");
  if (navBtn) {
    navBtn.textContent = "Add to Cart — " + displayPrice + " →";
  }
}

/* ── Savings bar ─────────────────────────────────────────────────── */

function updateSavingsBar() {
  var accessorySavings = Object.entries(giftState)
    .filter(function (entry) {
      return entry[1];
    })
    .reduce(function (sum, entry) {
      return sum + giftValues[entry[0]];
    }, 0);

  var total = getBaseDiscount() + accessorySavings;
  var tv = document.getElementById("gift-total-val");
  if (tv) {
    tv.textContent = "$" + total;
    tv.style.color = "var(--green-light)";
  }
  updateCtaButtons();
}

/* ── Gift toggling ───────────────────────────────────────────────── */

function toggleGift(id, val) {
  giftState[id] = !giftState[id];
  var el = document.getElementById("gift-" + id);
  if (el) el.classList.toggle("gift-selected", giftState[id]);
  updateSavingsBar();
}

/* ── Purchase type toggle ────────────────────────────────────────── */

function selectPurchaseType(type) {
  currentPurchaseType = type;

  var subRow = document.getElementById("subscribe-row");
  var subRadioDot = subRow ? subRow.querySelector(".sub-radio-dot") : null;
  var oneRow = document.getElementById("onetime-row");
  var oneRadio = document.getElementById("onetime-radio");

  if (type === "subscribe") {
    if (subRow) {
      subRow.style.borderColor = "rgba(42,157,143,0.4)";
      subRow.style.background = "rgba(42,157,143,0.06)";
    }
    if (subRadioDot) subRadioDot.style.display = "block";
    if (oneRow) {
      oneRow.style.opacity = "0.5";
      oneRow.style.background = "transparent";
      oneRow.style.border = "none";
    }
    if (oneRadio) {
      oneRadio.style.borderColor = "var(--border-subtle)";
      oneRadio.style.background = "transparent";
      oneRadio.innerHTML = "";
    }
  } else {
    if (subRow) {
      subRow.style.borderColor = "var(--border-subtle)";
      subRow.style.background = "transparent";
    }
    if (subRadioDot) subRadioDot.style.display = "none";
    if (oneRow) {
      oneRow.style.opacity = "1";
      oneRow.style.background = "rgba(42,157,143,0.04)";
      oneRow.style.border = "1px solid rgba(42,157,143,0.2)";
    }
    if (oneRadio) {
      oneRadio.style.background = "var(--accent)";
      oneRadio.style.border = "none";
      oneRadio.innerHTML =
        '<div style="width:9px;height:9px;border-radius:50%;background:#0E0F0D;margin:auto;margin-top:4px;"></div>';
    }
  }

  updateSavingsBar();
}

/* ── Add to Cart ─────────────────────────────────────────────────── */

var _addingToCart = false;

function getSelectedGiftVariantIds() {
  var ids = [];
  if (!variantMap || !variantMap.gifts) return ids;

  Object.keys(giftState).forEach(function (key) {
    if (giftState[key] && variantMap.gifts[key]) {
      ids.push(variantMap.gifts[key]);
    }
  });
  return ids;
}

function addToCart(btn) {
  if (_addingToCart) return;
  if (!currentVariantId) return;

  _addingToCart = true;
  var originalHtml = btn.innerHTML;
  btn.innerHTML = "Adding…";
  btn.disabled = true;

  // Collect cart-items section IDs for Section Rendering API
  var cartSectionIds = [];
  document.querySelectorAll("cart-items-component").forEach(function (el) {
    if (el.dataset && el.dataset.sectionId) {
      cartSectionIds.push(el.dataset.sectionId);
    }
  });

  // Build main product form data
  var formData = new FormData();
  formData.append("id", currentVariantId);
  formData.append("quantity", "1");

  // Append selling plan if subscribe is selected
  if (currentPurchaseType === "subscribe" && currentSellingPlanId) {
    formData.append("selling_plan", currentSellingPlanId);
  }

  if (cartSectionIds.length > 0) {
    formData.append("sections", cartSectionIds.join(","));
  }

  fetch("/cart/add.js", {
    method: "POST",
    body: formData,
  })
    .then(function (r) {
      return r.json();
    })
    .then(function (response) {
      if (response.status) {
        console.error(
          "Add to cart error:",
          response.description || response.message
        );
        btn.innerHTML = response.description || "Error";
        setTimeout(function () {
          btn.innerHTML = originalHtml;
        }, 3000);
        return;
      }

      // Now add selected free gift items
      var giftIds = getSelectedGiftVariantIds();
      var productId = variantMap ? variantMap.product_id : "";

      if (giftIds.length > 0) {
        var giftItems = giftIds.map(function (id) {
          return {
            id: id,
            quantity: 1,
            properties: { _free_gift: "true", _gift_parent: String(productId) },
          };
        });

        var giftBody = { items: giftItems };
        if (cartSectionIds.length > 0) {
          giftBody.sections = cartSectionIds.join(",");
        }

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(giftBody),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (giftResponse) {
            dispatchCartUpdate(giftResponse.sections, 1 + giftIds.length);
            pushAddToCartEvent();
          })
          .catch(function (err) {
            console.warn("Free gifts ATC error:", err);
            dispatchCartUpdate(response.sections, 1);
            pushAddToCartEvent();
          });
      } else {
        dispatchCartUpdate(response.sections, 1);
        pushAddToCartEvent();
      }

      // Brief "Added!" feedback on all CTA buttons
      var allCtaBtns = document.querySelectorAll(
        "#cta-btn, .final-cta .btn-primary, .btn-nav[data-ps-atc-btn]"
      );
      allCtaBtns.forEach(function (b) {
        var origHtml = b.innerHTML;
        b.innerHTML = "✓ Added!";
        setTimeout(function () {
          b.innerHTML = origHtml;
          updateCtaButtons();
        }, 1800);
      });
    })
    .catch(function (error) {
      console.error("Air Purifier ATC error:", error);
      btn.innerHTML = originalHtml;
    })
    .finally(function () {
      _addingToCart = false;
      btn.disabled = false;
      setTimeout(function () {
        if (btn.innerHTML === "Adding…") {
          btn.innerHTML = originalHtml;
        }
      }, 3000);
    });
}

function dispatchCartUpdate(sections, itemCount) {
  document.dispatchEvent(
    new CustomEvent("cart:update", {
      bubbles: true,
      detail: {
        resource: {},
        sourceId: "air-purifier",
        data: {
          source: "air-purifier",
          itemCount: itemCount,
          productId: variantMap ? variantMap.product_id : null,
          variantId: currentVariantId,
          sections: sections || null,
        },
      },
    })
  );

  try {
    var CartAddEvent = window.CartAddEvent;
    if (!CartAddEvent) {
      document.dispatchEvent(new CustomEvent("cart-add", { bubbles: true }));
    }
  } catch (e) {
    /* ignore */
  }
}

/* ── GTM / dataLayer tracking ────────────────────────────────────── */

function pushAddToCartEvent() {
  if (typeof window.TrainingAnalytics === "undefined") return;

  fetch("/cart.js")
    .then(function (r) {
      return r.json();
    })
    .then(function (cart) {
      window.TrainingAnalytics.pushEvent("add_to_cart", cart, {
        pageType: "product",
      });
    })
    .catch(function () {
      /* analytics failure is non-blocking */
    });
}

/* ── CTA click handler (delegated) ──────────────────────────────── */

document.addEventListener("click", function (e) {
  var atcBtn = e.target.closest("[data-ps-atc-btn]");
  if (!atcBtn) return;

  var section = document.querySelector(
    ".air-purifier-section[data-product-available]"
  );
  if (section && section.getAttribute("data-product-available") === "false")
    return;

  e.preventDefault();
  addToCart(atcBtn);
});

/* ── Shipping urgency ───────────────────────────────────────────── */

(function () {
  var now = new Date();
  var h = now.getHours();
  var days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  var today = now.getDay();

  var badge, sub;
  if (h < 14) {
    var minsLeft = 14 * 60 - (h * 60 + now.getMinutes());
    var hLeft = Math.floor(minsLeft / 60);
    var mLeft = minsLeft % 60;
    var timeStr = hLeft > 0 ? hLeft + "h " + mLeft + "m" : mLeft + " min";
    badge = "Order in " + timeStr + " — ships today";
    var delivDay = today === 6 ? days[1] : days[(today + 1) % 7];
    sub =
      "Arrives " +
      delivDay +
      ". Most people feel the difference within 48 hours of first use.";
  } else if (today < 5) {
    var delivDay2 = today === 4 ? "Monday" : days[today + 1];
    badge = "Ships tomorrow — arrives " + delivDay2;
    sub =
      "Start breathing better by " +
      delivDay2 +
      ". 100-day guarantee covers you either way.";
  } else {
    badge = "Ships Monday — arrives Tuesday";
    sub =
      "Start breathing better by Tuesday. 100-day guarantee covers you either way.";
  }

  var el1 = document.getElementById("slots-remaining");
  var el2 = document.getElementById("slots-remaining-2");
  if (el1) el1.textContent = badge;
  if (el2) el2.textContent = sub;
})();

/* ── FAQ accordion ───────────────────────────────────────────────── */

function toggleFaq(el) {
  var item = el.parentElement;
  var isOpen = item.classList.contains("open");
  document.querySelectorAll(".faq-item").forEach(function (i) {
    i.classList.remove("open");
    var q = i.querySelector(".faq-question");
    if (q) q.setAttribute("aria-expanded", "false");
  });
  if (!isOpen) {
    item.classList.add("open");
    el.setAttribute("aria-expanded", "true");
  }
}

/* ── Scroll-triggered fade-in ────────────────────────────────────── */

var observer = new IntersectionObserver(
  function (entries, obs) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = "1";
        entry.target.style.transform = "translateY(0)";
        obs.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.08 }
);

document
  .querySelectorAll(
    ".review-card, .cycle-card, .cert-row, .gift-review-item, .aqi-panel"
  )
  .forEach(function (el) {
    el.style.opacity = "0";
    el.style.transform = "translateY(16px)";
    el.style.transition = "opacity 0.55s ease, transform 0.55s ease";
    observer.observe(el);
  });

/* ── Anatomy block scroll reveal ─────────────────────────────────── */

var anatomyObserver = new IntersectionObserver(
  function (entries, obs) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible");
        obs.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.1 }
);

document.querySelectorAll("[data-anatomy]").forEach(function (el) {
  anatomyObserver.observe(el);
});

/* ── Smooth scroll to #buy ─────────────────────────────────────── */

document.querySelectorAll('a[href="#buy"]').forEach(function (a) {
  a.addEventListener("click", function (e) {
    var avail = document.querySelector(
      ".air-purifier-section[data-product-available]"
    );
    if (avail && avail.getAttribute("data-product-available") === "false")
      return;
    e.preventDefault();
    document
      .getElementById("buy")
      .scrollIntoView({ behavior: "smooth", block: "center" });
  });
});

/* ── Out-of-stock redirect ───────────────────────────────────────── */

function buildOutOfStockUrl() {
  var params = [];

  var selectedGifts = Object.keys(giftState).filter(function (key) {
    return giftState[key];
  });
  if (selectedGifts.length > 0) {
    params.push("gifts=" + encodeURIComponent(selectedGifts.join(",")));
  }

  params.push("purchase_type=" + encodeURIComponent(currentPurchaseType));

  var priceNum = Math.round(getActivePrice() / 100);
  params.push("price=" + encodeURIComponent(priceNum));

  var qs = params.length > 0 ? "?" + params.join("&") : "";
  return "/pages/out-of-stock" + qs;
}

(function () {
  var section = document.querySelector(
    ".air-purifier-section[data-product-available]"
  );
  if (!section) return;

  var isAvailable = section.getAttribute("data-product-available") !== "false";
  if (isAvailable) return;

  var allAtcBtns = document.querySelectorAll("[data-ps-atc-btn]");
  allAtcBtns.forEach(function (btn) {
    if (btn.classList.contains("btn-nav")) {
      btn.textContent = "Sold Out";
    } else {
      btn.innerHTML =
        'Sold Out — Join the Waitlist <span class="arrow">→</span>';
    }
    btn.style.opacity = "0.7";
    btn.style.pointerEvents = "auto";

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = buildOutOfStockUrl();
    });
  });
})();

/* ── Initialize savings bar ──────────────────────────────────────── */
updateSavingsBar();
